var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08366 3.83398H21.417C22.6087 3.83398 23.5837 4.69648 23.5837 5.75065V17.2507C23.5837 18.3048 22.6087 19.1673 21.417 19.1673H4.08366C2.89199 19.1673 1.91699 18.3048 1.91699 17.2507V5.75065C1.91699 4.69648 2.89199 3.83398 4.08366 3.83398Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5837 5.75L12.7503 12.4583L1.91699 5.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMessages);
export default __webpack_public_path__ + "static/media/HeaderMessages.a977156c2c1dfc1fea6b5bf3eab7e9f9.svg";
export { ForwardRef as ReactComponent };